import React from 'react';
import { Box } from '@mui/material';
import CustomizedTables from '../../common/Table';
import { deleteJob, getAllJobs } from './Jobs.service';

const Jobs = () => {
    const columns: any[] = [
        // { key: "id", label: "ID", minWidth: 90 },
        { key: "firstname", label: "First Name", minWidth: 150 },
        { key: "lastname", label: "Last Name", minWidth: 150 },
        { key: "jobtype", label: "Job Type", minWidth: 130 },
        { key: "email", label: "Email", minWidth: 130 },
        { key: "number", label: "Mobile Number", minWidth: 150 },
        { key: "description", label: "Description", minWidth: 150 },
        { key: "ticketAccount", label: "Ticket Account", minWidth: 100 },
    ];

    return (
        <Box sx={{ paddingY: 6, width: '100%' }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}><h2>Job List</h2>

                {/* <Button variant="contained" color="primary" size='small' sx={{
                    backgroundColor: "#10374A", // Custom background color
                    color: "#FFFFFF",           // Custom text color
                    "&:hover": {
                        backgroundColor: "#08293D", // Custom hover color
                    }, height: '40px' }} component={Link} to="/addJob">
                    Add New Job
                </Button> */}
            </Box>
            <CustomizedTables
                columns={columns}
                listService={getAllJobs}
                deleteService={deleteJob}
                isUser={true}
            // editLink={'/editProperty'}
            />
        </Box>
    );
};

export default Jobs;
